function formatIdName(obj: any) {
    const list = [];
    for (const key in obj) {
        list.push({ id: key, name: obj[key] });
    }
    return list;
}

/**
 * 可视化页面类型
 */
export const DESIGN_PAGE_TYPES = {
    home: '首页',
    topic: '专题活动',
    point: '积分商城',
    signIn: '每日签到',
    newProduct: '新品专区',
    mRights: '会员权益',
};

/**
 * 可视化页面跳转链接类型
 */
export const DESIGN_PAGE_LINK_TYPES = {
    none: '无链接',
    product: '商品详情',
    search: '搜索',
    ...DESIGN_PAGE_TYPES,
    sunbathingList: '晒单专区',
    link: '自定义链接',
    live: '直播列表',
    maintenance: '维修养护',
    customMade: '在线定制',
    userHome: '个人中心',
    sale: '华典回收',
    sell: '收购',
};

/**
 * 可视化页面跳转链接类型
 */
export const DESIGN_PAGE_LINK_HOT_TYPES = {
    none: '无链接',
    product: '商品详情',
    search: '搜索',
    hotZone: '图片热区',
    ...DESIGN_PAGE_TYPES,
    sunbathingList: '晒单专区',
    link: '自定义链接',
    live: '直播列表',
    maintenance: '维修养护',
    customMade: '在线定制',
    userHome: '个人中心',
    sale: '华典回收',
    sell: '收购',
};

/**
 * ｛id:1,name:'a'｝格式数据 页面类型
 */
export const DESIGN_PAGE_TYPES_LIST = formatIdName(DESIGN_PAGE_TYPES);

/**
 * ｛id:1,name:'a'｝格式数据 可视化链接跳转类型
 */
export const DESIGN_PAGE_LINK_TYPES_LIST = formatIdName(DESIGN_PAGE_LINK_TYPES);

/**
 * ｛id:1,name:'a'｝格式数据 可视化链接跳转类型(包含热区)
 */
export const DESIGN_PAGE_LINK_TYPES_HOT_LIST = formatIdName(DESIGN_PAGE_LINK_HOT_TYPES);

export const SIDEBARMENU_TYPES = {
    none: '无链接',
    product: '商品详情',
    search: '搜索',
    ...DESIGN_PAGE_TYPES,
    sunbathingList: '晒单专区',
    link: '自定义链接',
    live: '直播列表',
    liveItem: '直播间',
    maintenance: '维修养护',
    customMade: '在线定制',
    userHome: '个人中心',
    sale: '华典回收',
    sell: '收购',
    backToTop: '返回顶部',
    customerService: '客服',
    shoppingCart: '购物车',
};
/**
 * 侧边tab
 */
export const SIDEBARMENU_TYPE_LIST = formatIdName(SIDEBARMENU_TYPES);
